export default "__VITE_ASSET__81ThQ22R__"